import type { QuestionMessagePayload } from './questionMessage';

export type NormalizedChatMessage = {
  id: string;
  senderId: number;
  content: string;
  createdAt: string;
  kind?: string;
  question?: QuestionMessagePayload | null;
  status?: string;
  attachments?: {
    id: string;
    fileName: string;
    fileUrl: string;
    type: string;
    mimeType: string;
  }[];
  sender: {
    id: number;
    firstName: string | null;
    lastName: string | null;
    email: string;
    profileImg: string | null;
    role: string;
  };
  pending?: boolean;
  chatRequestId?: string;
};

export function normalizeApiMessage(raw: Record<string, unknown>): NormalizedChatMessage {
  const sender = (raw.sender as Record<string, unknown>) || {};
  const attachments = Array.isArray(raw.attachments)
    ? (raw.attachments as Record<string, unknown>[]).map((a) => ({
        id: String(a.id ?? raw.id),
        fileName: String(a.fileName || 'attachment'),
        fileUrl: String(a.fileUrl || ''),
        type: String(a.type || 'file'),
        mimeType: String(a.mimeType || a.type || 'application/octet-stream'),
      }))
    : [];

  return {
    id: String(raw.id),
    senderId: Number(raw.senderId ?? sender.id ?? 0),
    content: String(raw.content || ''),
    createdAt: String(raw.createdAt || new Date().toISOString()),
    kind: String(raw.kind || 'chat'),
    question: (raw.question as QuestionMessagePayload) || null,
    status: raw.status ? String(raw.status) : 'sent',
    attachments,
    sender: {
      id: Number(sender.id ?? raw.senderId ?? 0),
      firstName: (sender.firstName as string) ?? null,
      lastName: (sender.lastName as string) ?? null,
      email: String(sender.email || ''),
      profileImg: (sender.profileImg as string) || null,
      role: String(sender.role || ''),
    },
    pending: Boolean(raw.pending),
    chatRequestId: raw.chatRequestId
      ? String(raw.chatRequestId)
      : raw.chat_request_id != null
        ? String(raw.chat_request_id)
        : undefined,
  };
}
